module.exports = __webpack_public_path__ + "static/assets/108e5b4ea379d5016bf890cae91eff23.jpg";